module.exports = __webpack_public_path__ + "static/img/continuousFollow.7af3495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/continuousFollow.jpg
// module id = PaGj
// module chunks = 1